import { Box, Button, HStack, Icon, Text, VStack } from '@chakra-ui/react'
import { useContext } from 'react'
import attachFileIcon from '~/assets/svgs/icon-attach-file.svg?react'
import { useDropzoneStyles } from '~/components/shared/componentStyles/Dropzone.style'
import { Size } from '~/types/ThemeTypes'
import { formatFileSize } from '~/utils/common'

import { Context } from './Context'

export default function ContentAcceptedSingle() {
  const { acceptedFiles, currentVariant, resetAllState } = useContext(Context)

  const file = acceptedFiles[0]

  const styles = useDropzoneStyles({
    variant: currentVariant,
  })

  return (
    <>
      <HStack>
        <Icon sx={styles.icon} as={attachFileIcon} />
        <VStack>
          <Text sx={styles.text}>
            {file.name} ({formatFileSize(file.size)})
          </Text>
        </VStack>
      </HStack>
      <HStack>
        <Box
          as={Button}
          sx={styles.clearButton}
          variant="link"
          size={Size.sm}
          onClick={resetAllState}
        >
          Clear
        </Box>
      </HStack>
    </>
  )
}
